import {Component, OnInit} from '@angular/core';
import {DataSharing} from '../../helpers/core/data.sharing';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

    public _settings: any;
    public currentYear:number;
    constructor() {
        this.currentYear = new Date().getFullYear();
    }

    ngOnInit() {
        const portal_setting = DataSharing.GetJsonObj('settings');
        this._settings = {
            footer_text: portal_setting.footer_text,
            powered_by_title: portal_setting.powered_by_title
        };
    }
}
